import { enumDisplay } from './types/enums';

export class Modal {

    private modalDialog = $<HTMLDialogElement>(`dialog.modal`);
    private modalTitle = this.modalDialog?.querySelector(`.title`);
    private modalContent = this.modalDialog?.querySelector(`.content`);
    private modalClose = this.modalDialog?.querySelector(`i.close`);

    constructor() {
        !!this.modalClose && this.modalClose.addEventListener('click', this.close);
    }

    public show(title: string, content: string) {
        if (!!this.modalDialog && !!this.modalTitle && !!this.modalContent) {
            this.modalTitle.innerHTML = title;
            this.modalContent.innerHTML = content;
            // @ts-ignore
            this.modalDialog?.showModal();
        }
    }
    private close() {
        if (!!this.modalDialog && !!this.modalTitle && !!this.modalContent) {
            this.modalTitle.innerHTML = ``;
            this.modalContent.innerHTML = ``;
            // @ts-ignore
            this.modalDialog?.close();
        }
    }
}

export function pluralize(value: string, count: number): string {
    return (count == 1) ? value : `${value.substring(0,1)}${value.substring(1).toLowerCase()}s`;
}

export function append(el: HTMLElement | null | undefined, html: string) {
    !!el && el.insertAdjacentHTML('beforeend', html);
    return el;
}
export function stripDate(date: Date | number | string = 'now'): Date {
    let monthsArr = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    if (!(date instanceof Date)) {
        if (typeof date == 'number') {
            date = new Date(date)
        } else if (typeof date == 'string') {

            // get today's date
            let now = new Date();
            let YYYY: string = now.getFullYear().toString();
            let MM: string = now.getMonth().toString();
            let DD: string = now.getDate().toString();
            let month: string = monthsArr[+MM];

            if (date.indexOf(',') > 0) {
                // non ISO date format
                [month, DD, YYYY] = date.split(' ');
                DD = DD.substring(0, DD.length - 1);
                MM = monthsArr.indexOf(month).toString();
            } else if (date != 'now') {
                // assume ISO date format
                [YYYY, MM, DD] = date.split('-');
                MM = (+MM - 1).toString();
            }
            date = new Date(+YYYY, +MM, +DD);
        }
    }
    // strip the time to zero
    date.setHours(0, 0, 0, 0);

    return date;
}

export function checkVisible(el: HTMLElement) {
    var rect: DOMRect = el.getBoundingClientRect();
    var height: number = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || (rect.top - height) >= 0);
}
export function show(el: HTMLElement | null | undefined, display: enumDisplay = enumDisplay.SHOW) {
    !!el && (el.style.display = display);
}
export function hide(el: HTMLElement | null | undefined) {
    !!el && (el.style.display = enumDisplay.HIDE);
}

export function getURLParamByName(param: string, url?: string) {
    url || (url = window.location.href), (param = param.replace(/[\[\]]/g, `\\$&`));
    var matches = new RegExp(`[?&]${param}(=([^&#]*)|&|#|$)`).exec(url);
    return matches ? (matches[2] ? decodeURIComponent(matches[2].replace(/\+/g, ` `)) : ``) : null;
}

export function makeElement<T extends keyof HTMLElementTagNameMap>(args: {
    elementName: T,
    id?: string,
    className?: string,
    innerHTML?: string,
    href?: string,
    attributes?: Array<{[key: string]: string}>
}) : HTMLElementTagNameMap[T] {
    let element = document.createElement<T>(args.elementName);
    !!args.id && element.setAttribute(`id`, args.id);
    !!args.className && element.classList.add(...args.className.split(` `));
    !!args.innerHTML && (element.innerHTML = args.innerHTML);
    !!args.href && element instanceof HTMLAnchorElement && (element.href = args.href);
    args.attributes?.forEach( attribute => {
        const key = Object.keys(attribute)[0];
        element.setAttribute(key, attribute[key]);
    })
    return element;
}

export function $<T extends HTMLElement>(selector: string) : T | null {
    if (selector.substring(0,1) == "#") {
        return document.getElementById(selector.substring(1)) as T | null;
    } else {
        return document.querySelector(selector) as T | null;
    }
}

export function adjustTextarea(e: KeyboardEvent) {
    var key = (e as KeyboardEvent).key;
    if ([` `, `Enter`, `Backspace`, `Delete`].indexOf(key) >= 0) {
        console.log(key);
        var el = e.currentTarget as HTMLTextAreaElement;
        var clog = el.value.length % 10 == 0;
        var value = el.value;
        var lines = (
            value = (
                value.replace(new RegExp(`\n\r`, `gi`), `\n`)
            ).replace(new RegExp(`\r`, `gi`), `\n`)
        ).split(`\n`);
        var hr = (lines.length > 2) ? lines.length : 2;
        lines.forEach((line, index) => {
            var sr = Math.floor(line.length / 87.5) // the number of soft returns this line requires
            if (sr >= 1) {                          // if we require any soft returns...
                hr = hr + sr;                       // add them to the line count
            }
        })
        el.rows = hr;
    }
}
